import React, {useState} from 'react';
import {FloatButton} from "antd";
import classes from './lan.module.css';
import ru_flag from '../../../images/lanFlags/ru_flag_icon.png';
import kz_flag from '../../../images/lanFlags/kaz_glag_icon.png';
import en_flag from '../../../images/lanFlags/eng_flag_icon.png';
import i18n from "i18next";

const LanguageButton = () => {
    const [selectedLan, setSelectedLan] = useState({
        value: localStorage.getItem('lan'),
        label: localStorage.getItem('lan')
    });

    const [open, setOpen] = useState(false);

    const kz = {
        value: "ҚАЗ",
        label: "ҚАЗ",
        ii8n: "kk"
    }

    const ru = {
        value: "РУС",
        label: "РУС",
        ii8n: "ru"
    }

    const en = {
        value: "ENG",
        label: "ENG",
        ii8n: "en"
    }

    const changeLang = (selectedLang) => {
        localStorage.setItem('lan', selectedLang.value);
        setSelectedLan(selectedLang);
        i18n.changeLanguage(selectedLang.ii8n);
        setOpen(false);
    }

    const selectedIconLan = selectedLan.value === 'РУС' ? <FlagIcon text={"РУ"}/> : selectedLan.value === 'ҚАЗ' ? <FlagIcon text={"ҚЗ"}/> : selectedLan.value === 'ENG' ? <FlagIcon text={"EN"}/> : <FlagIcon text={"РУ"}/>

    return (
        <FloatButton.Group
            trigger="click"
            style={{
                right: 24,
                bottom: 48
            }}
            icon={selectedIconLan}
            open={open}
            onClick={() => {
                setOpen(!open);
            }}
        >
            {/*<FloatButton onClick={() => {changeLang(eng)}} icon={<FlagIcon icon={eng_flag}/>}/>*/}
            <FloatButton onClick={() => {changeLang(kz)}} icon={<FlagIcon text={"ҚЗ"}/>}/>
            <FloatButton onClick={() => {changeLang(ru)}} icon={<FlagIcon text={"РУ"}/>}/>
            <FloatButton onClick={() => {changeLang(en)}} icon={<FlagIcon text={"EN"}/>}/>
        </FloatButton.Group>
    );
};

export default LanguageButton;

const FlagIcon = ({text}) => {
    return (
        <div className={classes.iconFlagBlock}>
            <p>{text}</p>
            {/*<img src={icon} alt=""/>*/}
        </div>
    );
};